import { LinearProgress, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { uniqueId } from "lodash";
import { useTranslation } from "react-i18next";

import { insuranceInformationColumns } from "./cols";
import { getMappedRequestType } from "./util";
import { InsuranceTransaction } from "../../../models/Customer";
import CustomPagination from "../../atoms/CustomPagination";
import EmptyState from "../../atoms/EmptyState";
import { styles } from "../insuranceInformation/DataGrid.styles";
interface InsuranceTransactionDataGridProps {
  data?: InsuranceTransaction;
  loading?: boolean;
  onPageChange: (page: number) => void;
  signupCountry: string;
}

const InsuranceTransactionDataGrid = ({
  data,
  loading,
  onPageChange,
  signupCountry,
}: InsuranceTransactionDataGridProps) => {
  const { t } = useTranslation();
  const transactions =
    signupCountry &&
    data?.transactions?.map(el => {
      const lokaliseKey = getMappedRequestType(
        el.transationName,
        signupCountry,
      ).key;
      return {
        ...el,
        transationName: t(lokaliseKey),
      };
    });
  return (
    <Stack height={666}>
      <DataGrid
        columnHeaderHeight={52}
        rowHeight={56}
        loading={loading}
        data-testid="insurance-transaction-table"
        sx={styles.table}
        isRowSelectable={() => false}
        rows={transactions || []}
        columns={insuranceInformationColumns}
        getRowId={() => uniqueId()}
        slots={{
          pagination: CustomPagination,
          loadingOverlay: LinearProgress,
          noRowsOverlay: EmptyState,
        }}
        slotProps={{
          pagination: {
            count: data?.pagination?.totalPages,
            page: (data?.pagination?.currentPage ?? 1) - 1,
            onPageChange: (_, page) => {
              onPageChange(page + 1);
            },
          },
        }}
      />
    </Stack>
  );
};

export default InsuranceTransactionDataGrid;
